<template>
	<div>
		<h3>{{ $t("components.checkout.bill.title") }}</h3>

		<template v-if="order">
			<div
					class="section"
				>
				<h4
					v-html="`Kit Ricette`"
          v-if="order.prices.plan > 0"
				/>
				<div v-for="(recipe, index) in order.recipes" :key="`${index}`" class="bill-item">
					<div class="recipe-image">
						<img :src="recipe.images.big">
					</div>
					<div
						class="recipe-name"
					>
						<div v-html="recipe.name" />
						<div class="info-small-normal">({{ order.plan.people * recipe.quantity }} porzioni)</div>
					</div>
				</div>

				<!--<div v-if="maxRecipes >= recipes.length">
					<div
						v-for="(n, index) in (maxRecipes - meals)"
						:key="`placeholder-${index}`"
						class="bill-item placeholder"
					>
						<div class="recipe-image placeholder flex-center" >	
							<img :src="require('../../assets/img/plate.png')">
						</div>		
						<span
							v-html='`Aggiungi Ricetta`'
						/>
					</div>
				</div>-->

			</div>
			<h4
				v-html="`Bottega`" v-if="order.prices.plan > 0"
			/>

			<div class="section" v-if="order.extras.length > 0">
				<div v-if="order.extras.length <= 0">Aggiungi i tuoi preferiti </div>

				<div v-for="(extra, index) in order.extras" v-if="extra.quantity > 0" :key="index">
					<div class="flex flex-vcenter bill-item">
						<div class="inline recipe-image" v-if="extra.images">
							<img :src="extra.images.big">
						</div>

						<div>
							<div>{{ extra.title }}</div>
							<div class="info-small-normal">Quantità: {{ extra.quantity }}</div>
						</div>


					</div>
				</div>

			</div>


			<shipment-select
	            v-if="$mq.isDesktop()"
	        />
			<hr>


			<div class="flex" v-if="order.prices.plan > 0">
				<div>{{ $t("components.checkout.bill.total_plan") }}</div>
				<div class="flex-right">{{ order.prices.plan | priceFilter }}</div>
			</div>
			<div
				class="flex"
				v-if="order.prices.recipes > 0"
			>
				<div>Premium</div>
				<div class="flex-right">{{ order.prices.recipes | priceFilter }}</div>
			</div>
			
			<div
				class="flex"
				v-if="order.extras.length > 0"
			>
				<div>Bottega</div>
				<div class="flex-right">{{ order.prices.extras | priceFilter }}</div>
			</div>


			<div class="flex">
				<div :class="{'text-bold': $root.source === 'bennet'}">
					{{ $t("components.checkout.bill.total_delivery") }}
				</div>

				<div class="flex-right" :class="{'text-bold': $root.source === 'bennet'}" v-if="order.prices.delivery > 0">
					{{ order.prices.delivery | deliveryPrice }}
				</div>

				<div class="flex-right" v-else>
					<div class="delivery-free-bill">GRATUITA</div>
				</div>
			</div>

			<div class="flex" v-if="orderHasDiscount">
				<div>{{ $t("components.checkout.bill.total_discount") }}</div>
				
				<div class="flex-right">– {{ order.prices.discount | priceFilter }}</div>
			</div>

			<div class="flex text-bold">
				<div>{{ $t("components.checkout.bill.total_total") }}</div>
				<div class="flex-right">{{ order.prices.net | priceFilter }}</div>
			</div>

			<div class="" v-if="orderHasEdenred">
				<br>
				<div class="flex">
					<div class="flex-right">di cui {{ order.transactions.edenred | priceFilter }} pagati in Buoni Pasto</div>
				</div>
			</div>
			<div class="mt-3" style="line-height: 1.3; font-size: 14px">
				<small v-if="$route.name === 'order-now' && order.prices.delivery > 0">*Consegna gratuita disponibile con l'abbonamento attivo!</small>
			</div>
		</template>

		<template v-else>
			<loading-spin
                :height='100'
                v-if="!stop"
            />
		</template>
	</div>
</template>

<script>
import { orderStore } from '../../store/orderStore'
import { prices } from '../../mixins/prices'

import ShipmentSelect from '../Delivery/ShipmentSelect'

export default {
	data () {
		return {
			orderStore: orderStore.state,
		}
	},

	props: {
		stop: {
			type: Boolean,
			default: false
		}
	},

	mixins: [
		prices
	],

	components: {
		ShipmentSelect
	},

	filters: {
		deliveryPrice (val) {
			if (val === '0.00') return 'GRATUITA'
			return `€ ${val.replace('.', ',')} `
		}
	},

	computed: {
		user () {
			return this.$root.$data.user
		},

		order () {
			return this.orderStore.order
		},
	}
}

</script>

<style scoped>
	h3 {
		font-weight: bold;
		margin-bottom: 30px;
		text-align: left;
	}

	h4 {
		font-size: 14px;
		margin-bottom: 5px;
		font-weight: 500;
	}

	select {
		padding: 0 10px;
		border: 1.5px solid #EDEDED;
		background: #ffffff99;
		color: #575A5C;
		width: 100%;
		outline: none;
		height: 36px;
		border-radius: 4px;
	}

	.small-text {
		font-size: 13px;
		padding-top: 6px;
	}


.recipe-image {
	min-width: 50px;
	min-height: 33px;
	max-width: 50px;
	max-height: 33px;
	overflow: hidden;
	vertical-align: middle;
	margin-right: 10px;
	border-radius: 4px;
}

.recipe-image.placeholder {
	text-align: center;
}

.recipe-image.placeholder img {
	width: 75%;
}


.bill-item {
	margin: 10px 0;
	display: flex;
    align-items: center;
    line-height: 1.2;
}

.bill-item .recipe-name {
	display: -webkit-box;
    -webkit-box-orient: vertical;
    position: relative;
	line-height: 1.1;
	overflow: hidden;
}

.bill-item.placeholder {
	color: #9ea0a1;
	background-color: #fbf1d7;
	background-color: #fffefba3;
	padding: 7px 0;
}

.delivery-free-bill {
	text-transform: uppercase;
	font-weight:bold;
}

</style>
